export default __webpack_public_path__ + "static/media/calendar-icon.5070baf8.svg";